import { render, staticRenderFns } from "./CorporateActivity.vue?vue&type=template&id=f1412262&scoped=true"
import script from "./CorporateActivity.vue?vue&type=script&lang=js"
export * from "./CorporateActivity.vue?vue&type=script&lang=js"
import style0 from "./CorporateActivity.vue?vue&type=style&index=0&id=f1412262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1412262",
  null
  
)

export default component.exports